import { SampleAPI } from "@/Features/Drydock/SampleApi/sampleapi";
import Divider from "@common/Divider";
import { Category } from "./Category/category";
import { Option } from "./Options/option";
import { OptionValue } from "./Options/optionValue";
import { VariantOptionsPicker } from "./Options/variantOptionsPicker";
import { Vendor } from "./Vendors/vendor";
import { ProductDrydock } from "./Products/product";
import { PaymentTokenization } from "./Payments/paymentTokenization";
import { BankTokenization } from "./Payments/bankTokenization";
import { ComponentColor } from "@common/types";
import { Title } from "@common/index";

export const Drydock = () => {
    return (
        <div className="bg-base-content min-h-screen text-neutral">
            <Title>Development workbench</Title>

            <Divider color={ComponentColor.Primary} />

            <SampleAPI />
            
            <Divider color={ComponentColor.Primary} />

            <Category />

            <Divider color={ComponentColor.Primary} />

            <div className="flex">
                <Option />
                <OptionValue />
            </div>

            <Divider color={ComponentColor.Primary} />

            <VariantOptionsPicker />

            <Divider color={ComponentColor.Primary} />

            <Vendor />

            <Divider color={ComponentColor.Primary} />

            <ProductDrydock />

            <Divider color={ComponentColor.Primary} />

            <PaymentTokenization />

            <Divider color={ComponentColor.Primary} />

            <BankTokenization />
        </div>
    );
};
